import { render } from "./FormularioContatoProcesso.vue?vue&type=template&id=31855bbf"
import script from "./FormularioContatoProcesso.vue?vue&type=script&lang=js"
export * from "./FormularioContatoProcesso.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Legalize/CadastroDeProcessos/Components/FormularioContatoProcesso.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31855bbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31855bbf', __exports__)) {
    console.log('reload')
    api.reload('31855bbf', __exports__)
  }
  
  module.hot.accept("./FormularioContatoProcesso.vue?vue&type=template&id=31855bbf", () => {
    console.log('re-render')
    api.rerender('31855bbf', render)
  })

}


export default __exports__